import React from "react";
import { useId } from "react-id-generator";

const SvgCircle = ({
    id = 'default',
    color1 = "black",
    color2 = "black",
    r1 = 50,
    r2 = 25
}) => {

    const size = r1 * 2;

    const [ maskId, gradientId ] = useId(2,'svgDef-'); 

    return (
        <svg height={size} width={size}>
            <defs>
                <mask id={maskId}>
                    <rect x="0" y="0" width={size} height={size} fill="white" />
                    <circle cx={r1} cy={r1} r={r2} />
                </mask>
                {/* <!-- Fill circle with a gradient --> */}
                <defs>
                    <linearGradient
                        id={gradientId}
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                    >
                        <stop offset="0%" stop-color={color1} />
                        <stop offset="100%" stop-color={color2} />
                    </linearGradient>
                </defs>
            </defs>
            <circle
                cx={r1}
                cy={r1}
                r={r1}
                mask={`url(#${maskId})`}
                fill={`url(#${gradientId})`}
            />
        </svg>
    );
};

export default SvgCircle;



// WEBPACK FOOTER //
// ./src/components/svgCircle.js